/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlignCenterV: {
  name: 'align-center-v';
  data: string;
} = {
  name: 'align-center-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 4a1 1 0 1 0-2 0v16a1 1 0 1 0 2 0V4ZM5.293 9.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414L5.586 13H2a1 1 0 1 1 0-2h3.586l-.293-.293a1 1 0 0 1 0-1.414Zm13.414 0a1 1 0 0 1 0 1.414l-.293.293H22a1 1 0 1 1 0 2h-3.586l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 0Z" fill="currentColor"/></svg>`,
};
